import PropTypes from "prop-types";
import { useEffect } from "react";
import { useAuthContext } from "../useAuthContext";

// ----------------------------------------------------------------------

export const Login = ({ returnTo }) => {
  const { login } = useAuthContext();

  useEffect(() => {
    login(returnTo);
  }, [login, returnTo]);

  return <></>;
};

Login.propTypes = {
  returnTo: PropTypes.string,
};
